import { render, staticRenderFns } from "./upload-dragger.vue?vue&type=template&id=71bc3468&"
import script from "./upload-dragger.vue?vue&type=script&lang=js&"
export * from "./upload-dragger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports